module.exports = __webpack_public_path__ + "static/img/logo-todomath-for-web-cn@3x.c59bba4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo-todomath-for-web-cn@3x.png
// module id = lQIB
// module chunks = 18